import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import { ActionsEnum } from '@connect-services/client/models/panel.model';
import {
    ContentLayoutService,
    HORIZONTAL_HOME_GRID_PARAMS,
} from '@connect-services/client/services/content-layout.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-create-field-intervention-information',
    styleUrl: './create-field-intervention-information.component.scss',
    templateUrl: './create-field-intervention-information.component.html',
})
export class CreateFieldInterventionInformationComponent {
    public readonly icon = input.required<IconProp>();
    public readonly isMapOneThirdHorizontal: Signal<boolean> = computed(
        () => this.contentLayoutService.mapSizeType() === HORIZONTAL_HOME_GRID_PARAMS.ONE_THIRD_HORIZONTAL,
    );
    public readonly size = input<SizeProp | undefined>();
    public readonly subTitle = input.required<string>();
    public readonly title = input.required<string>();

    protected readonly ActionsEnum = ActionsEnum;

    private readonly contentLayoutService = inject(ContentLayoutService);
}
